import React from "react";
import { useFormState } from "react-hook-form";
import {
  ErrorMessage,
  Props as ErrorMessageProps,
} from "@hookform/error-message";

import { Text } from "../Text";

export type FormErrorProps = Omit<ErrorMessageProps<any, any>, "render"> & {
  children?: ErrorMessageProps<any, any>["render"];
};

const defaultRender: FormErrorProps["children"] = ({ message }) => {
  return (
    <Text color="error" mt="6px">
      {message}
    </Text>
  );
};

export const FormError = (props: FormErrorProps) => {
  const { errors } = useFormState();

  return (
    <ErrorMessage
      name={props.name}
      errors={errors}
      render={props.children || defaultRender}
    />
  );
};

FormError.displayName = "FormError";

export default FormError;
